export default {
  interactions: [],
  interactionStates: [],
  interactionAttempts: [],
  interactionMetas: [],
  concurrentInteractions: [],
  discussionComments: {},
  discussionInteractionHasCommentReplies: false,
  discussionCommentsShowReplies: [],
  editFreeResponseState: false, 
  oldDiscussionComments: [],
  activeInteraction: null,
  interactionGroups: [],
  rubricSubmitting: false,
  rubricSubmitted: 0, // displayTime of when the rubric was submitted, necessary for determining end of bulb Toast message
  defaultInteraction: {
    interactionOptions: []
  },
  defaultInteractionAttempt: {
    responseText: [],
    interactionOptionIds: []
  },
  defaultInteractionMeta: {},
  dummyCommentSubmitted: false,
  hotspotPositionsArray:[],
  interactionContinueButtonShouldBeHidden: false,
}